import {array, boolean, InferType, number, object, string} from 'yup';

import {stakeV8nSchema} from '@entities/stake';
import {paginationV8nSchema} from '@shared/api';

const outcomeSchema = object({
  event_id: string().required(),
  event_slug: string().required(),
  event_status: string().required(),
  real: number().required(),
  promo: number().required(),
  participants: number().required(),
  voided: boolean().required(),
});

export const poolSchema = object({
  group_id: string().required(),
  topic_id: string().required(),
  status: string().required(),
  real: number().required(),
  promo: number().required(),
  participants: number().required(),
  winner_event_id: string().nullable().defined(),
  payable: number().nullable().defined(),
  winner_total: number().nullable().defined(),
  created_at: string().required(),
  updated_at: string().required(),
  outcomes: array().of(outcomeSchema).required(),
  stakes: array().of(stakeV8nSchema).optional(),
});
export const responseSchema = paginationV8nSchema.shape({
  array: array().of(poolSchema).required(),
});
export const userPoolsResponseSchema = paginationV8nSchema.shape({
  array: array()
    .of(poolSchema.shape({stakes: array().of(stakeV8nSchema).required()}))
    .required(),
});
export type PoolResponse = InferType<typeof responseSchema>;
